export default "__VITE_ASSET__BD$FCwxW__"